import React, { Component } from 'react';
import Wrapper              from './../components/Wrapper';
import Banner               from '../components/containers/BannerContainer';
import PageContent          from './../components/containers/PageContentContainer';
import Footer               from '../components/containers/FooterContainer';

class Places extends Component
{
    resolvePage = () =>
    {
        let value = 'about';
        let key   = 'label';

        if (typeof this.props.route.label !== 'undefined')
        {
            value = this.props.route.label;
        }
        else if (typeof this.props.params.id !== 'undefined')
        {
            key  = 'id';
            value = this.props.params.id
        }

        return {
            key: key,
            value: value
        }
    };

    render = () =>
    {
        let pageData = this.resolvePage();

        return (
            <div>
                <Banner />
                <div style={{ marginTop: 10 }}>&nbsp;</div>
                <Wrapper>
                    <PageContent keyName={ pageData.key } value={ pageData.value } />
                </Wrapper>
                <Wrapper outerClass="footer">
                    <Footer />
                </Wrapper>
            </div>
        );
    }
}

export default Places;


// WEBPACK FOOTER //
// ./src/pages/Page.js